import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';

/** Ein Weg, über den beschafft werden kann — Libri, Umbreit, Verlag … */
export type Beschaffungsweg = {
  id: number;
  code: string;
  label: string;
  sort_order: number;
};

type LookupResponse<T> = { type: string; items: T[] };

export function useBeschaffungswege() {
  return useQuery({
    queryKey: ['lookups', 'beschaffungswege'],
    queryFn: () =>
      apiFetch<LookupResponse<Beschaffungsweg>>('/lookups.php?type=beschaffungswege'),
    staleTime: 10 * 60_000
  });
}
